import dayjs from 'dayjs';
import { atom } from 'recoil';

import type {
  BrandsFilters,
  CampaignFiltersAtom,
  InfluencersFilters,
  InfluentiaUsersFilters,
  InvoicesFilters,
  SingleCampaignMainInfo,
  SingleUser,
} from '../types';
import type { ControlPiecesFilters } from '../types/control';
import type { ProposalFiltersAtom } from '../types/proposal';

export const userAtom = atom({
  key: 'user', // unique ID
  default: {} as SingleUser, // default value
});

export const apolloErrorModal = atom({
  key: 'apolloErrorModal', // unique ID
  default: {
    errors: [],
    show: false,
  } as { errors: string[]; show: boolean }, // default value
});

export const campaignFilterAtom = atom<CampaignFiltersAtom | null>({
  key: 'campaignFilterAtom',
  default: null,
});
export const campaignFilterUserAtom = atom<CampaignFiltersAtom | null>({
  key: 'campaignFilterUserAtom',
  default: null,
});
export const campaignFilterBrandAtom = atom<CampaignFiltersAtom | null>({
  key: 'campaignFilterBrandAtom',
  default: null,
});

export const influencersFilterAtom = atom<InfluencersFilters | null>({
  key: 'influencersFilterAtom',
  default: null,
});

export const influentiaUsersFilterAtom = atom<InfluentiaUsersFilters | null>({
  key: 'influentiaUsersFilterAtom',
  default: null,
});

export const brandsFilterAtom = atom<BrandsFilters | null>({
  key: 'brandsFilterAtom',
  default: null,
});

export const prospectsFilterAtom = atom<BrandsFilters | null>({
  key: 'prospectsFilterAtom',
  default: null,
});

export const controlScheduledPiecesFilterAtom =
  atom<ControlPiecesFilters | null>({
    key: 'controlScheduledPiecesFilterAtom',
    default: {
      month_from: dayjs().format('MM/YYYY'),
      month_to: dayjs().format('MM/YYYY'),
      has_publication_date: true,
    },
  });

export const influencersInvoicesFilterAtom = atom<InvoicesFilters | null>({
  key: 'influencersInvoicesFilterAtom',
  default: null,
});

export const brandsInvoicesFilterAtom = atom<InvoicesFilters | null>({
  key: 'brandsInvoicesFilterAtom',
  default: null,
});

export const loadingAuthAtom = atom<boolean>({
  key: 'loadingAuthAtom',
  default: true,
});

export const singleCampaignInfoAtom = atom<SingleCampaignMainInfo | null>({
  key: 'singleCampaignInfo',
  default: null,
});

export const proposalFilterAtom = atom<ProposalFiltersAtom | null>({
  key: 'proposalFilterAtom',
  default: null,
});
